<template>
    <div class="game-info-title" :class="{ 'is-center': isCenter }">
        <div class="game-info-title-text">
            <div class="title-area">
                <p>{{ title }}</p>
            </div>
        </div>
        <div class="game-info-title-extra">
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        isCenter: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang='scss' scoped>
.game-info-title {
    position: relative;
    height: 1.03rem;
    background-image: url('../../../../../assets/img/gl/gameInfo/game_info_title.png');
    background-repeat: no-repeat;
    background-position: left center;
    background-size: contain;
    padding-left: .4rem;
    display: flex;
    align-items: center;

    &-text {
        width: 100%;
        height: .4rem;
        border-bottom: .01rem solid #d3d5d8;

        .title-area {
            height: 100%;
            position: relative;
            font-size: .3rem;
            color: #23323d;
            display: inline-block;
            padding: 0 .3rem 0 0;
            border-bottom: .04rem solid #23323d;

            P {
                font-weight: bold;
                text-align: left;
                transform: translateY(-.01rem);
            }
        }
    }

    &-extra{
        height: .4rem;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0;
    }

    &.is-center {
        background-position: center;
        padding-left: 0;

        .game-info-title-text {
            display: flex;
            align-items: center;
            justify-content: center;
            

            .title-area {
                padding: 0 .3rem;
                text-align: center;
            }
        }
    }
}</style>